import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { SimpleFlexbox } from '../../flexbox/flexbox';
import styles from './product_compare_wrapper.css';

const ProductCompareWrapper = ({ isVisible, children }) => (
    <div className={classNames({ [styles.layout]: true, [styles.slide_out]: !isVisible })}>
        <div className={styles.root}>
            <SimpleFlexbox display="flex" contentCenter="xs" padding="all_xsmall">
                {children}
            </SimpleFlexbox>
        </div>
    </div>
);

ProductCompareWrapper.propTypes = {
    isVisible: PropTypes.bool,
    children: PropTypes.node
};

export { ProductCompareWrapper };
